import { type ReactNode } from 'react';
import { EmptyState } from '@/components/ui/empty-state';
import { useAiAppeals } from '../hooks/use-ai-appeals';
import { AiAppealRow } from './ai-appeal-row';

function AppealsList({
  items,
}: {
  items: ReturnType<typeof useAiAppeals>['data'];
}): ReactNode {
  if (!items || items.totalItems === 0) {
    return <EmptyState title="No hay apelaciones pendientes." />;
  }
  return (
    <div className="flex flex-col gap-sm">
      {items.items.map((c) => (
        <AiAppealRow key={c.id} creator={c} />
      ))}
    </div>
  );
}

export function AiAppealsPage(): ReactNode {
  const q = useAiAppeals();
  return (
    <div className="mx-auto max-w-[960px] space-y-lg">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-lg font-bold text-text-primary">
          Apelaciones IA pendientes
        </h1>
        {q.data && (
          <span className="text-xs text-text-tertiary">
            {q.data.totalItems} apelacion{q.data.totalItems === 1 ? '' : 'es'}
          </span>
        )}
      </div>
      {q.isLoading ? (
        <p className="text-text-tertiary text-sm">Cargando...</p>
      ) : (
        <AppealsList items={q.data} />
      )}
    </div>
  );
}
